import React from "react";

export default function StarRating({
  value = 0,
  onChange,
  size = 32,
  readOnly = false,
  color = "#F59E0B",
}) {
  const stars = [1, 2, 3, 4, 5];

  return (
    <div className="flex items-center gap-1">
      {stars.map((star) => (
        <button
          key={star}
          type="button"
          disabled={readOnly}
          onClick={() => onChange && onChange(star)}
          className={`transition-transform ${readOnly ? "cursor-default" : "cursor-pointer hover:scale-110 active:scale-95"}`}
          style={{ padding: 0, background: "none", border: "none" }}
        >
          <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill={star <= value ? color : "none"}
            stroke={star <= value ? color : "#D1D5DB"}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
          </svg>
        </button>
      ))}
    </div>
  );
}
